import React, { useRef, useEffect } from "react";

function useOutsideAlerter(ref, func, searchText) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        func("none");
      } else {
        if (document.getElementById("search").value.length > 0) {
          func("flex");
        }
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
}

function OutsideAlerter(props) {
  const wrapperRef = useRef(null);
  useOutsideAlerter(
    wrapperRef,
    props.hideOrShowSearchResults,
    props.searchText
  );
  return (
    <div
      className={
        props.className ||
        "list-inline-item d-none d-lg-flex align-items-center w-50 custom-search-li"
      }
      ref={wrapperRef}
    >
      {props.children}
    </div>
  );
}

export default OutsideAlerter;
